/* ============================================================
   Sleep in Africa — carte, quiz et configurateur.
   Portage des blocs MAP, QUIZ et CONFIGURATOR de la maquette.

   Trois différences avec la maquette, toutes délibérées.

   1. Les données ne sont plus écrites dans ce fichier. Elles viennent des
      sections, publiées en JSON. La liste des destinations n'existe qu'à un
      seul endroit — la carte — parce que la saisir deux fois, c'est la voir
      diverger.

   2. Rien n'est appelé directement d'une section à l'autre. Dans la maquette,
      la carte appelle setCfgDest() du configurateur ; si le configurateur
      n'est pas sur la page, tout s'arrête. Ici la carte émet un événement, et
      qui veut l'écoute. Chaque section fonctionne seule.

   3. Tout est gardé. Une section absente, une liste vide, un JSON mal formé :
      la fonction concernée se retire et le dit dans la console, au lieu de
      lever une erreur qui tuerait le reste de la page.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function readJSON(selector, what) {
    var el = $(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[SIA] ' + what + ' : JSON illisible, section ignorée.', e);
      return null;
    }
  }

  // Les destinations peuvent être publiées par la carte, par le quiz ou par le
  // configurateur — chacun peut vivre sur sa propre page. On réunit donc toutes
  // les listes présentes, et on écarte les doublons par identifiant : deux
  // sections branchées sur la même collection ne doivent pas produire deux fois
  // la même destination, ce qui donnerait deux points superposés sur la carte.
  //
  // La première occurrence gagne, dans l'ordre du document : si la carte est sur
  // la page, c'est sa version qui prime, et elle est la seule à porter les
  // coordonnées du point.
  var DESTS = (function () {
    var seen = {}, all = [];
    $$('[data-sia-destinations]').forEach(function (el) {
      var list;
      try {
        list = JSON.parse(el.textContent);
      } catch (e) {
        console.warn('[SIA] destinations : JSON illisible, liste ignorée.', e);
        return;
      }
      if (!Array.isArray(list)) return;
      list.forEach(function (d) {
        if (!d || !d.id || seen[d.id]) return;
        seen[d.id] = true;
        all.push(d);
      });
    });
    return all;
  })();
  var byId = function (id) { return DESTS.filter(function (d) { return d.id === id; })[0]; };

  // « São Tomé », « Sao Tome », « sao tome » : trois façons d'écrire la même
  // chose. Ce qui est saisi dans le quiz est comparé aux titres des produits,
  // et personne ne devrait avoir à reproduire un accent à l'identique pour que
  // la correspondance se fasse.
  function fold(s) {
    s = String(s == null ? '' : s).trim().toLowerCase();
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) { /* vieux moteur */ }
    return s;
  }
  var byName = function (n) {
    n = fold(n);
    return DESTS.filter(function (d) { return fold(d.name) === n; })[0];
  };

  /* Trouve une destination à partir de ce qui a été écrit à la main : son nom,
     son identifiant, ou le début de son nom si un seul y répond. Deux
     candidats, c'est une ambiguïté — on préfère ne rien renvoyer et le dire
     plutôt que choisir au hasard. */
  function resolveDest(raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (!s) return null;
    var d = byName(s);
    if (d) return d;
    d = byId(fold(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''));
    if (d) return d;
    var low = fold(s);
    var hits = DESTS.filter(function (x) { return fold(x.name).indexOf(low) === 0; });
    return hits.length === 1 ? hits[0] : null;
  }

  /* Une même destination choisie ici doit se répercuter là : un événement,
     pas un appel de fonction. */
  function announce(id) {
    document.dispatchEvent(new CustomEvent('sia:destination', { detail: { id: id } }));
  }

  var money = function (n, cur, loc) {
    try {
      return new Intl.NumberFormat(loc || 'en-IE',
        { style: 'currency', currency: cur || 'EUR', maximumFractionDigits: 0 }).format(n);
    } catch (e) { return Math.round(n) + ' ' + (cur || 'EUR'); }
  };


  /* ---------------------------------------------------------- CARTE */
  (function map() {
    var pins = $('#pins'), info = $('#mapInfo');
    if (!pins || !info) return;
    if (!DESTS.length) {
      console.warn('[SIA] carte : aucune destination saisie.');
      return;
    }
    var cfgTexts = readJSON('[data-sia-map-texts]', 'textes de la carte') || {};
    var txt = function (k, d) { return cfgTexts[k] != null && cfgTexts[k] !== '' ? cfgTexts[k] : d; };

    // L'adresse de la page qui porte le formulaire, réglée dans la section.
    // Vide, on retombe sur l'ancre — le comportement d'avant, pour une page qui
    // porterait carte et formulaire ensemble.
    function formLink(d, extra) {
      var base = txt('form_url', '');
      if (!base) return '#plan';
      return base + (base.indexOf('?') < 0 ? '?' : '&') +
             'destination=' + encodeURIComponent(d.name) + (extra || '');
    }
    /* Où mène le panneau.
       ---------------------
       Une destination désigne d'abord sa propre page — celle du produit quand
       la carte est branchée sur une collection. À défaut, la page de sa
       famille : voyages privés ou départs en groupe. À défaut encore, on
       retombe sur le comportement de la maquette : le configurateur s'il est
       sur la page, sinon le formulaire.

       Le bouton du configurateur ne s'ajoute que lorsqu'il ne fait pas double
       emploi : il n'est là que si le visiteur a déjà une page où aller, sinon
       c'est lui qui tient le rôle principal. */
    function kindLabel(d) {
      return d.kind === 'group' ? txt('kind_group', 'Small-group departure')
                                : txt('kind_private', 'Private journey');
    }
    function actions(d) {
      var out = [];
      var page = d.url || d.hub || '';
      var cfgId = txt('cfg_anchor', 'configurator');
      var hasCfg = !!(cfgId && document.getElementById(cfgId));
      var pageLabel = d.kind === 'group' ? txt('cta_group', 'See this departure →')
                                         : txt('cta_live', 'See this journey →');
      if (page) {
        out.push('<a href="' + page + '" class="btn btn-primary">' + pageLabel + '</a>');
      } else if (d.live) {
        out.push('<a href="' + (hasCfg ? '#' + cfgId : formLink(d, '')) +
                 '" class="btn btn-primary" data-go="' + d.id + '">' + pageLabel + '</a>');
      }
      if (d.live && page && hasCfg && txt('cta_budget', '')) {
        out.push('<a href="#' + cfgId + '" class="btn btn-ghost" data-go="' + d.id + '">' +
                 txt('cta_budget', '') + '</a>');
      }
      if (!d.live) {
        out.push('<a href="' + formLink(d, '&waitlist=1') + '" class="btn btn-ghost" data-waitlist="' +
                 d.id + '">' + txt('cta_soon', 'Join the waitlist →') + '</a>');
      }
      // Un seul bouton reste nu, comme dans la maquette : l'enveloppe n'existe
      // que quand il y en a deux. Aucun bouton n'en laisse aucune.
      if (!out.length) return '';
      return out.length === 1 ? out[0] : '<div class="map-cta">' + out.join('') + '</div>';
    }

    DESTS.forEach(function (d) {
      var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      g.setAttribute('class', 'pin' + (d.live ? ' live' : (d.coming ? ' coming' : '')));
      g.setAttribute('tabindex', '0');
      g.setAttribute('role', 'button');
      g.setAttribute('aria-label', d.name);
      var extra = '';
      if (d.coming) {
        extra = '<text class="pin-label" x="' + (d.x + 16) + '" y="' + (d.y + 6) + '">' + d.name + '</text>' +
                '<text class="pin-label" x="' + (d.x + 16) + '" y="' + (d.y + 27) +
                '" style="font-size:14px;fill:var(--faint)">' + txt('soon_label', 'coming soon') + '</text>';
      }
      g.innerHTML =
        '<circle class="ring" cx="' + d.x + '" cy="' + d.y + '" r="9"></circle>' +
        '<circle class="hit" cx="' + d.x + '" cy="' + d.y + '" r="22"></circle>' +
        '<circle class="dot" cx="' + d.x + '" cy="' + d.y + '" r="8"></circle>' + extra;
      var sel = function () { select(d.id); };
      g.addEventListener('click', sel);
      g.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sel(); }
      });
      pins.appendChild(g);
    });

    function select(id) {
      var d = byId(id);
      if (!d) return;
      $$('.pin').forEach(function (p) { p.classList.remove('on'); });
      var node = pins.children[DESTS.indexOf(d)];
      if (node) node.classList.add('on');
      info.innerHTML =
        '<span class="badge ' + (d.live ? 'live' : 'soon') + '">' +
          (d.live ? txt('badge_live', '● Available now') : txt('badge_soon', '○ Coming soon')) + '</span>' +
        '<h3>' + d.name + '</h3><div class="coord mono">' + (d.coord || '') + '</div>' +
        '<p>' + (d.blurb || '') + '</p>' +
        '<div class="facts">' +
          // La famille s'écrit, elle ne se devine pas à la couleur du point :
          // celle-ci dit déjà si la destination est ouverte ou à venir.
          (txt('label_kind', '') ? '<div><span>' + txt('label_kind', '') + '</span><b>' + kindLabel(d) + '</b></div>' : '') +
          // Une date de départ ne concerne qu'un voyage à date fixe : la ligne
          // n'existe que si la destination en porte une.
          (d.dates ? '<div><span>' + txt('label_dates', 'Departure dates') + '</span><b>' + d.dates + '</b></div>' : '') +
          (d.region ? '<div><span>' + txt('label_region', 'Region') + '</span><b>' + d.region + '</b></div>' : '') +
          (d.season ? '<div><span>' + txt('label_season', 'Best season') + '</span><b>' + d.season + '</b></div>' : '') +
          (d.days ? '<div><span>' + txt('label_days', 'Typical length') + '</span><b>' + d.days + ' ' + txt('label_days_unit', 'days') + '</b></div>' : '') +
          (d.from ? '<div><span>' + txt('label_from', 'From') + '</span><b>' + money(d.from, cfgTexts.currency, cfgTexts.locale) + '</b></div>' : '') +
        '</div>' +
        // « Join the waitlist » n'est pas une action sur la page : c'est une
        // demande. Elle part donc toujours vers le formulaire. Jusqu'ici elle
        // descendait vers une ancre #plan et n'emportait rien : la demande
        // arrivait sans dire de quelle destination il s'agissait, ni qu'il
        // s'agissait d'une liste d'attente.
        actions(d);
      // Tous les boutons qui restent sur la page, pas seulement le premier :
      // le panneau peut en porter deux, et celui du configurateur est le second.
      $$('[data-go]', info).forEach(function (go) {
        go.addEventListener('click', function () { announce(d.id); });
      });
      var wl = info.querySelector('[data-waitlist]');
      if (wl) wl.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('sia:waitlist', { detail: { id: d.id, name: d.name } }));
      });
    }

    select(DESTS[0].id);
    document.addEventListener('sia:destination', function (e) {
      if (byId(e.detail.id)) select(e.detail.id);
    });
  })();

  /* ---------------------------------------------------------- QUIZ */
  (function quiz() {
    var body = $('#quizBody'), result = $('#quizResult'), foot = $('#quizFoot');
    if (!body || !result || !foot) return;
    var conf = readJSON('[data-sia-quiz]', 'quiz');
    if (!conf || !conf.questions || !conf.questions.length) {
      console.warn('[SIA] quiz : aucune question saisie.');
      return;
    }
    var Q = conf.questions.filter(function (q) { return q.q && q.opts && q.opts.length; });
    if (!Q.length) return;

    /* « Zanzibar:2 | Cape Verde » -> {id: poids}. Un nom inconnu est signalé
       plutôt qu'ignoré en silence : c'est une faute de saisie, pas un choix. */
    function weights(spec) {
      var out = {};
      String(spec || '').split('|').forEach(function (part) {
        part = part.trim();
        if (!part) return;
        var bits = part.split(':');
        var d = resolveDest(bits[0]);
        if (!d) { console.warn('[SIA] quiz : destination inconnue « ' + bits[0].trim() + ' »'); return; }
        out[d.id] = (out[d.id] || 0) + (parseFloat(bits[1]) || 1);
      });
      return out;
    }

    var idx = 0, scores = {};
    function renderQ() {
      result.classList.remove('show');
      body.style.display = '';
      foot.style.display = 'flex';
      var q = Q[idx];
      $('#qStep').textContent = (conf.stepLabel || 'Question') + ' ' + (idx + 1) + ' / ' + Q.length;
      var pct = Math.round((idx / Q.length) * 100) + Math.round(100 / Q.length);
      $('#qFill').style.width = pct + '%';
      $('#qPct').textContent = pct + '%';
      body.innerHTML = '<h3></h3><p class="qhint"></p><div class="qopts"></div>';
      body.querySelector('h3').textContent = q.q;
      body.querySelector('.qhint').textContent = q.h || '';
      var wrap = body.querySelector('.qopts');
      q.opts.forEach(function (o) {
        var b = document.createElement('button');
        b.className = 'qopt';
        var ic = document.createElement('span'); ic.className = 'qic'; ic.textContent = o.ic || '';
        var col = document.createElement('span');
        var t = document.createElement('b'); t.textContent = o.t;
        var s = document.createElement('small'); s.textContent = o.s || '';
        col.appendChild(t); col.appendChild(s);
        b.appendChild(ic); b.appendChild(col);
        b.addEventListener('click', function () {
          var w = weights(o.d);
          for (var k in w) scores[k] = (scores[k] || 0) + w[k];
          if (idx < Q.length - 1) { idx++; renderQ(); } else { showResult(); }
        });
        wrap.appendChild(b);
      });
      $('#qBack').style.visibility = idx === 0 ? 'hidden' : 'visible';
    }

    function showResult() {
      body.style.display = 'none';
      foot.style.display = 'none';
      $('#qFill').style.width = '100%';
      $('#qPct').textContent = '100%';
      $('#qStep').textContent = conf.resultStep || 'Result';
      var live = DESTS.filter(function (d) { return d.live; });
      if (!live.length) { console.warn('[SIA] quiz : aucune destination disponible.'); return; }
      var best = live[0], bs = -1;
      live.forEach(function (d) {
        var v = scores[d.id] || 0;
        if (v > bs) { bs = v; best = d; }
      });
      $('#rName').textContent = best.name;
      $('#rMatch').textContent = String(conf.matchLabel || '✦ {match}% match · {coord}')
        .replace('{match}', Math.min(99, 72 + bs * 4)).replace('{coord}', best.coord || '');
      $('#rDesc').textContent = String(conf.descTemplate || '{blurb}')
        .replace('{blurb}', best.blurb || '').replace('{days}', best.days || '')
        .replace('{season}', best.season || '');
      result.classList.add('show');
      var cta = $('#rCta');
      if (cta) {
        // Le bouton du résultat mène au voyage recommandé, pas à une page
        // générique : le visiteur vient de se voir nommer une destination, la
        // suite logique est de la lui montrer. Un lien saisi dans l'éditeur
        // reste prioritaire — c'est un choix explicite, il l'emporte.
        if (!conf.ctaLink && (best.url || best.hub)) cta.href = best.url || best.hub;
        cta.onclick = function () { announce(best.id); };
      }
    }

    $('#qBack').addEventListener('click', function () { if (idx > 0) { idx--; renderQ(); } });
    var reset = function () { idx = 0; scores = {}; renderQ(); };
    $('#qReset').addEventListener('click', reset);
    $('#rRestart').addEventListener('click', reset);
    renderQ();
  })();

  /* ---------------------------------------------------- CONFIGURATEUR */
  (function configurator() {
    var destWrap = $('#cfgDest'), days = $('#cfgDays'), trav = $('#cfgTrav');
    if (!destWrap || !days || !trav) return;
    var conf = readJSON('[data-sia-configurator]', 'configurateur') || {};

    /* Une destination sans tarif journalier ne peut pas produire d'estimation.
       Elle est retirée du choix : mieux vaut son absence qu'un montant inventé. */
    var LIVE = DESTS.filter(function (d) { return d.live && d.rate > 0; });
    if (!LIVE.length) {
      console.warn('[SIA] configurateur : aucune destination disponible avec un tarif journalier.');
      var host = destWrap.closest('.shopify-section');
      if (host) host.hidden = true;
      return;
    }

    var cfg = {
      dest: LIVE[0].id,
      days: Number(conf.daysDefault) || 10,
      comfort: 1, comfortLabel: '',
      trav: Number(conf.travDefault) || 2,
      vibe: ''
    };

    var firstComfort = $('#cfgComfort button.on') || $('#cfgComfort button');
    if (firstComfort) {
      cfg.comfort = parseFloat(firstComfort.dataset.m) || 1;
      cfg.comfortLabel = firstComfort.dataset.l || firstComfort.textContent.trim();
      firstComfort.classList.add('on');
    }
    var firstVibe = $('#cfgVibe button.on') || $('#cfgVibe button');
    if (firstVibe) { cfg.vibe = firstVibe.dataset.v || ''; firstVibe.classList.add('on'); }

    LIVE.forEach(function (d) {
      var b = document.createElement('button');
      b.textContent = d.name;
      b.dataset.id = d.id;
      if (d.id === cfg.dest) b.classList.add('on');
      b.addEventListener('click', function () { cfg.dest = d.id; seg(destWrap, b); render(); });
      destWrap.appendChild(b);
    });

    function seg(wrap, btn) {
      $$('button', wrap).forEach(function (x) { x.classList.remove('on'); });
      btn.classList.add('on');
    }

    days.addEventListener('input', function (e) { cfg.days = +e.target.value; render(); });
    $$('#cfgComfort button').forEach(function (b) {
      b.addEventListener('click', function () {
        cfg.comfort = parseFloat(b.dataset.m) || 1;
        cfg.comfortLabel = b.dataset.l || b.textContent.trim();
        seg($('#cfgComfort'), b); render();
      });
    });
    $$('#cfgVibe button').forEach(function (b) {
      b.addEventListener('click', function () { cfg.vibe = b.dataset.v || ''; seg($('#cfgVibe'), b); render(); });
    });
    var max = Number(conf.travMax) || 12;
    var plus = $('#cfgPlus'), minus = $('#cfgMinus');
    if (plus) plus.addEventListener('click', function () { cfg.trav = Math.min(max, cfg.trav + 1); trav.value = cfg.trav; render(); });
    if (minus) minus.addEventListener('click', function () { cfg.trav = Math.max(1, cfg.trav - 1); trav.value = cfg.trav; render(); });
    trav.addEventListener('input', function () {
      var v = parseInt(trav.value, 10);
      if (isNaN(v)) v = 1;
      cfg.trav = Math.max(1, Math.min(max, v));
    });
    trav.addEventListener('blur', function () { trav.value = cfg.trav; render(); });

    function groupFactor(n) {
      var rules = (conf.groupFactors || []).slice().sort(function (a, b) { return b.from - a.from; });
      for (var i = 0; i < rules.length; i++) if (n >= rules[i].from) return Number(rules[i].factor) || 1;
      return 1;
    }

    function render() {
      var d = byId(cfg.dest) || LIVE[0];
      var round = Number(conf.rounding) || 5;
      var per = Math.round(d.rate * cfg.days * cfg.comfort * groupFactor(cfg.trav) / round) * round;
      var unit = conf.daysUnit || 'days';
      var set = function (id, v) { var el = $(id); if (el) el.textContent = v; };
      set('#cfgDaysVal', cfg.days + ' ' + unit);
      set('#sumDest', d.name);
      set('#sumDays', cfg.days + ' ' + unit);
      set('#sumComfort', cfg.comfortLabel);
      set('#sumTrav', cfg.trav);
      set('#sumPer', money(per, conf.currency, conf.locale));
      set('#sumTotal', money(per * cfg.trav, conf.currency, conf.locale));
    }

    document.addEventListener('sia:destination', function (e) {
      var d = byId(e.detail.id);
      if (!d || !d.rate) return;
      cfg.dest = d.id;
      $$('#cfgDest button').forEach(function (b) { b.classList.toggle('on', b.dataset.id === d.id); });
      if (d.days) { cfg.days = d.days; days.value = d.days; }
      render();
      var host = document.getElementById('configurator') || destWrap.closest('.shopify-section');
      if (host) host.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
    });

    render();
  })();

  /* ------------------------------------------------ FORMULAIRE : L'ARRIVÉE */
  /* Le formulaire vit sur sa propre page. Les boutons des pages voyage et de la
     carte l'atteignent avec ?destination=… — Liquid ne sait pas lire un
     paramètre d'URL, c'est donc ici que ça se fait.

     Deux règles.

     On ne sélectionne que ce qui existe déjà dans la liste. Ajouter l'option à
     la volée enverrait à Make une valeur hors du vocabulaire convenu, et
     personne ne le verrait avant de chercher pourquoi un scénario ne se
     déclenche pas. Une valeur inconnue laisse donc la liste telle quelle, et le
     dit dans la console.

     On ne touche jamais au message : c'est le texte du visiteur. */
  (function formArrival() {
    var dest = document.querySelector('select[name="contact[destination]"]');
    if (!dest || !window.URLSearchParams) return;
    var params = new URLSearchParams(window.location.search);

    var wanted = (params.get('destination') || '').trim();
    if (wanted) {
      var match = null;
      $$('option', dest).forEach(function (o) {
        if (o.value && o.value.trim().toLowerCase() === wanted.toLowerCase()) match = o;
      });
      if (match) {
        dest.value = match.value;
      } else {
        console.warn('[SIA] formulaire : destination « ' + wanted +
                     ' » absente de la liste, aucune sélection faite.');
      }
    }

    // Une inscription en liste d'attente est une demande d'un autre genre.
    // Le champ part vide sur une demande ordinaire : les scénarios Make qui
    // l'ignorent ne voient aucune différence.
    var kind = document.querySelector('input[name="contact[request_type]"]');
    if (kind && params.get('waitlist')) kind.value = 'waitlist';
  })();
})();
